module.exports = __webpack_public_path__ + "static/home_galeria_3-6c40a98eead95b205d7ebbe14497ce6e.jpg";